export default function getImageIndexFromDGS(dgs = '') {
  const imageIndex = Number(dgs.split('_')[1])
  return !Number.isNaN(imageIndex) ? imageIndex : '-'
}
